/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import cloneDeep from 'lodash/cloneDeep';
import {
  SET_DATA,
  UPDATE_DOCUMENT,
  SIGNED_DOCUMENT,
  DECLINED_DOCUMENT,
  ADD_NEW_BIOSAMPLE_CODE,
  UPDATE_BIOSAMPLE_CODE,
  REMOVE_BIOSAMPLE_CODE
} from './constants';

// getUpdatedDocuments :: ([Object], Object) -> [Object]
const getUpdatedDocuments = (docs, newDoc) =>
  docs.map((doc) => (doc.documentGid === newDoc.documentGid ? newDoc : doc));

// getUpdatedQuestions :: Symbol -> Object -> [Object]
const getUpdatedQuestions =
  (type) =>
  ({ questions, questionId, newBiosampleCode, updatedBiosampleCode, removedBiosampleId }) => {
    switch (type) {
      case ADD_NEW_BIOSAMPLE_CODE: {
        return cloneDeep(questions).map((q) =>
          q.questionId === questionId ? { ...q, biosamples: q.biosamples.concat(newBiosampleCode) } : q
        );
      }
      case UPDATE_BIOSAMPLE_CODE: {
        return cloneDeep(questions).map((q) =>
          q.questionId === questionId
            ? {
                ...q,
                biosamples: q.biosamples.map((item) =>
                  item.id === updatedBiosampleCode.id ? updatedBiosampleCode : item
                )
              }
            : q
        );
      }
      case REMOVE_BIOSAMPLE_CODE: {
        return cloneDeep(questions).map((q) =>
          q.questionId === questionId
            ? { ...q, biosamples: q.biosamples.filter((item) => item.id !== removedBiosampleId) }
            : q
        );
      }
    }
  };

// getNewState :: hook reducer action Object A, hook reducer state Object S => String -> (S, A) -> S
const getNewState = (type) => (state, action) => {
  const { documentType, documentGid, questionId, newBiosampleCode, updatedBiosampleCode, removedBiosampleId } =
    action.payload;

  const documentsData = state[documentType];
  const updatedDocument = documentsData.find((d) => d.documentGid === documentGid);
  const { questions } = updatedDocument;

  const updatedDocumentQuestions = getUpdatedQuestions(type)({
    questions,
    questionId,
    newBiosampleCode,
    updatedBiosampleCode,
    removedBiosampleId
  });

  let { signed, declined, permissions } = state;

  documentType === SIGNED_DOCUMENT &&
    (signed = getUpdatedDocuments(signed, { ...updatedDocument, questions: updatedDocumentQuestions }));
  documentType === DECLINED_DOCUMENT &&
    (declined = getUpdatedDocuments(declined, { ...updatedDocument, questions: updatedDocumentQuestions }));

  return { signed, declined, permissions };
};

const updateDocumentState = (state, { document, documentType }) => {
  let { signed, declined, permissions } = state;

  if (documentType === 'signed') {
    signed = signed.map((stateDocument) => {
      if (document.documentGid === stateDocument.documentGid) return { ...document, versions: stateDocument.versions };
      return stateDocument;
    });
  }

  if (documentType === 'declined') {
    {
      declined = declined.map((stateDocument) => {
        if (document.documentGid === stateDocument.documentGid)
          return { ...document, versions: stateDocument.versions };
        return stateDocument;
      });
    }
  }

  return { signed, declined, permissions };
};

function dataReducer(state, action) {
  switch (action.type) {
    case SET_DATA:
      return action.payload;
    case UPDATE_DOCUMENT:
      return updateDocumentState(state, action.payload);
    case ADD_NEW_BIOSAMPLE_CODE: {
      return getNewState(ADD_NEW_BIOSAMPLE_CODE)(state, action);
    }
    case UPDATE_BIOSAMPLE_CODE: {
      return getNewState(UPDATE_BIOSAMPLE_CODE)(state, action);
    }
    case REMOVE_BIOSAMPLE_CODE: {
      return getNewState(REMOVE_BIOSAMPLE_CODE)(state, action);
    }
    default:
      return state;
  }
}

export default dataReducer;
